/* eslint-disable @typescript-eslint/no-empty-object-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, forwardRef, useMemo } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

interface GLTFResult extends THREE.Group {
  nodes: {
    [key: string]: THREE.Mesh;
    //"your-animated-mesh-name": THREE.Mesh; // Add the specific animated mesh name
  };
  materials: {
    [key: string]: THREE.Material;
  };
  scene: THREE.Group;
  animations: THREE.AnimationClip[];
}

export const tankAndFish2 = forwardRef<THREE.Group, {}>((props, ref) => {
  const sceneRef = useRef<THREE.Group>(null);

  const { scene, animations } = useGLTF(
    "/tank and fish.glb"
  ) as unknown as GLTFResult;

  const animationName = "Armature.001Action";

  // Use useAnimations on the specific animated mesh ref
  const { mixer, actions } = useAnimations(animations, sceneRef);

  // Synchronize the local sceneRef with the forwarded ref
  useEffect(() => {
    if (ref) {
      if (typeof ref === "function") {
        ref(sceneRef.current);
      } else {
        (ref as React.MutableRefObject<THREE.Group | null>).current =
          sceneRef.current;
      }
    }
  }, [sceneRef, ref]);

  useEffect(() => {
    Object.values(actions).forEach((action) => {
      if (action) {
        console.log("Playing action:", action);
        action.setLoop(THREE.LoopRepeat, Infinity);
        action.reset().play();
      }
    });
  }, [actions]);

  // Update the animation mixer on every frame
  useFrame((state, delta) => {
    if (mixer) {
      mixer.update(delta);
    }
  });

  useEffect(() => {
    if (!sceneRef.current) return;

    // const meshName = "Fish_01"; // Replace with the actual name of your animated mesh
    // const action = actions[animationName];
    // Use an effect to find the specific mesh and add a click handler
    //   const meshToAnimate = sceneRef.current.getObjectByName(meshName);
    //   if (meshToAnimate && meshToAnimate instanceof THREE.Mesh) {
    //     // Here we add the click handler directly to the Three.js object
    //     meshToAnimate.userData.onClick = (event: any) => {
    //       event.stopPropagation();
    //       if (action) {
    //         action.reset().play();
    //       }
    //     };
    //   }

    sceneRef.current.traverse((node) => {
      if (node instanceof THREE.Mesh) {
        if (node.name.startsWith("tank") || node.name.startsWith("pebbles")) {
          node.receiveShadow = false;
        } else {
          node.castShadow = false;
          node.receiveShadow = false;
        }
      }
    });
  }, [scene]);

  return <primitive object={scene} ref={sceneRef} {...props} />;
});
